import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import RowButtons from './../../components/button/RowButtons';
import RowChangeButton from './../../components/button/RowChangeButton';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextDate from './../../components/text/TextDate';
import TextBoolean from 'components/text/TextBoolean';
import InputDropDownList from './../../components/input/InputDropDownList';
import EditFormFieldTable from 'components/form/EditFormFieldTable';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const AgreementList = ({ }) => {
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const [list1Original, setList1Original] = useState([]);
  const [list2Original, setList2Original] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const [listCreditors, setCreditors] = useState([]);
  const [listCContracts, setCContracts] = useState([]);

  const [workingData, setWorkingData] = useState({
    credID: null,
    collContrID: null
  });

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const loadList = async () => {
    const data = await apiGetCall(BASE_URL + '/admin/agreements/summary');
    if (isResultOk(data, setListError, true)) {
      setList1(data.filter(agr => agr.agreementType == "Niðurfellingarsamningur"));
      setList2(data.filter(agr => agr.agreementType == "Ráðstöfunarsamningur"));

      setList1Original(data.filter(agr => agr.agreementType == "Niðurfellingarsamningur"));
      setList2Original(data.filter(agr => agr.agreementType == "Ráðstöfunarsamningur"));
    }
    setListLoading(false);
  }

  const loadCreditors = async () => {
    const data = await apiGetCall(BASE_URL + '/admin/agreement/connectedcontract/creditors');
    if (isResultOk(data, setListError,true)){
      setCreditors(data);
    }
  }

  const credSelected = async(item) => {
    setWorkingData({ ...workingData, credID: item });
    if (item == null){
      setCContracts(null);
      setList1(list1Original);
      setList2(list2Original);
    }
    else {
      setCContracts(listCreditors.filter(c => c.itemID == item)[0].data);
      setList1(list1Original);
      setList2(list2Original);
      console.log(listCreditors.filter(c => c.itemID == item)[0].data);
    }
    
  }

  const ccSelected = async(item) => {
    setWorkingData({ ...workingData, collContrID: item });
    if (item == null){
      setList1(list1Original);
      setList2(list2Original);
    }
    else {
      setList1(list1Original.filter(l1 => l1.collectionContractIDs.find(i => i == item) ));
      setList2(list2Original.filter(l2 => l2.collectionContractIDs.find(i => i == item) ));
    }
  }

  useEffect(() => {
    loadList();
    loadCreditors();
  }, []);



  return (
    <div>
      <ListHeader title={t("Samningar")} />
      <div>
      <EditFormFieldTable fields={[
          {
            title: "Kröfuhafar",
            edit: () => <InputDropDownList
              name="CreditorID"
              disabled={false}
              list={listCreditors}
              keyField="itemID"
              displayField={(item) => { return item.name }}
              defaultValue={workingData.credID}
              onChange={(value) => credSelected(value)}
              nullable={true}
              nullableItem={{ itemID: null, name: "Velja kröfuhafa" }}
            />
          },
          {
            title: "Innheimtusamningar",
            edit: () => <InputDropDownList
              name="CollContrID"
              disabled={false}
              list={listCContracts}
              keyField="itemID"
              displayField={(item) => { return item.name }}
              defaultValue={workingData.collContrID}
              onChange={(value) => ccSelected(value)}
              nullable={true}
              nullableItem={{ itemID: null, name: "Velja innheimtusamning" }}
            />
          },
        ]} />
        <div className="text-right"><Link to="/admin/agreements/create?agrTypeID=1" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Búa til nýjan niðurfellingarsamning")}</Link></div>
        <ListTable
          error={listError}
          isLoading={listLoading}
          list={list1}
          colsettings={['30%', '15%', '15%', '15%', '10%', '15%']}
          headers={[
            t("Tegund"),
            t("Nafn"),
            t("Frá"),
            t("Til"),
            t("Virkt"),
            t("Skráð"),
            ""
          ]}
          columns={[
            (item) => <>{item.agreementType}</>,
            (item) => <>{item.name}</>,
            (item) => <TextDate value={item.activeFrom} />,
            (item) => <TextDate value={item.activeTo} />,
            (item) => <TextBoolean value={item.active} />,
            (item) => <TextDate value={item.created} />,
            (item) => (<RowButtons>
              <RowChangeButton link={"/admin/agreements/edit?agrID=" + item.agreementID} />
            </RowButtons>),
          ]}

        />

        <div className="text-right"><Link to="/admin/agreements/create?agrTypeID=2" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Búa til nýjan ráðstöfunarsamning")}</Link></div>
        <ListTable
          error={listError}
          isLoading={listLoading}
          list={list2}
          colsettings={['30%', '15%', '15%', '15%', '10%', '15%']}
          headers={[
            t("Tegund"),
            t("Nafn"),
            t("Frá"),
            t("Til"),
            t("Virkt"),
            t("Skráð"),
            ""
          ]}
          columns={[
            (item) => <>{item.agreementType}</>,
            (item) => <>{item.name}</>,
            (item) => <TextDate value={item.activeFrom} />,
            (item) => <TextDate value={item.activeTo} />,
            (item) => <TextBoolean value={item.active} />,
            (item) => <TextDate value={item.created} />,
            (item) => (<RowButtons>
              <RowChangeButton link={"/admin/agreements/edit?agrID=" + item.agreementID} />
            </RowButtons>),
          ]}

        />
      </div>
    </div>

  );
};

